import React, { Component } from 'react'
import { InputSearchLayout, PageContainerLayout, PageHeaderLayout, PaginationLayout } from '../../../layouts'
import { GroupsHeaderTiles, GroupsTable } from '../../../shared/containers'
import { groupOperations } from '../../../../state/ducks/groups'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { GroupShape, PaginationShape } from '../../../../prop-types'

class GroupsPage extends Component {
  constructor (props) {
    super(props)

    this.state = {
      params: {}
    }
    this.fetchGroups = this.fetchGroups.bind(this)
    this.onPaginationChange = this.onPaginationChange.bind(this)
    this.onSearchChange = this.onSearchChange.bind(this)
    this.updateParams = this.updateParams.bind(this)
  }

  UNSAFE_componentWillMount () {
    this.fetchGroups()
  }

  fetchGroups () {
    this.props.fetchGroups(this.state.params)
  }

  onPaginationChange (page) {
    this.updateParams('page', page)
  }

  onSearchChange (keywork) {
    this.updateParams('search', keywork)
  }

  updateParams (key, value) {
    const { params } = this.state
    params[key] = value
    if (key === 'search') {
      params.page = 1
    }
    this.setState({
      params
    }, () => this.fetchGroups())
  }

  renderHeaderPaths () {
    return (
            <>
                <li>Groups</li>
            </>
    )
  }

  render () {
    return (
            <>
                <PageContainerLayout>
                    <PageHeaderLayout title={'Groups'} subTitle={'All groups'}
                                      paths={this.renderHeaderPaths}/>
                    {/* Page Content */}
                    <div className="content content-boxed">
                        {/* Header Tiles */}
                        <GroupsHeaderTiles all_groups={this.props.paginationData.totalItems}/>
                        {/* END Header Tiles */}
                        <div className={' block block-themed block-opt-refresh-icon7 ' + (this.props.isLoading ? ' block-opt-refresh ' : '')}>
                            <div className="block-header bg-primary-dark">
                                <ul className="block-options">
                                    <li>
                                        <button type="button"
                                                data-toggle="block-option"
                                                data-action="refresh_toggle"
                                                data-action-mode="demo"
                                                onClick={this.fetchGroups}
                                        >
                                            <i className="si si-refresh"></i>
                                        </button>
                                    </li>
                                </ul>
                                <h3 className="block-title">All groups</h3>
                            </div>
                            <div className="block-content">
                                {/* Search */}
                                <InputSearchLayout onSearchChange={this.onSearchChange}/>
                                {/* End Search */}
                                {/* Table */}
                                <GroupsTable groups={this.props.groups}>
                                    {/* Pagination */}
                                    <PaginationLayout pagination={this.props.paginationData}
                                                      onPaginationChange={this.onPaginationChange}/>
                                    {/* End Pagination */}
                                </GroupsTable>
                                {/* End Table */}
                            </div>
                        </div>
                    </div>
                    {/* END Page Content */}
                </PageContainerLayout>
            </>
    )
  };
}

// Set propTypes
const { arrayOf, func } = PropTypes
GroupsPage.propTypes = {
  groups: arrayOf(GroupShape).isRequired,
  fetchGroups: func.isRequired,
  paginationData: PaginationShape
}

// Set defaultProps
GroupsPage.defaultProps = {
  groups: [],
  paginationData: {}
}

// mapStateToProps
const mapStateToProps = (state) => ({
  isLoading: state.groups.fetchGroupsReducer.loading,
  groups: state.groups.fetchGroupsReducer.data.results,
  paginationData: state.groups.fetchGroupsReducer.data.pagination_data
})

// mapStateToProps
const mapDispatchToProps = {
  fetchGroups: groupOperations.list
}

// Export Class
const _GroupsPage = connect(mapStateToProps, mapDispatchToProps)(GroupsPage)
export { _GroupsPage as GroupsPage }
